import React, { useEffect } from 'react'
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react'
import clsx from 'clsx'

/**
 * Toast - Notification toast component
 */
const Toast = ({ message, type = 'info', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration)
      return () => clearTimeout(timer)
    }
  }, [duration, onClose])

  const config = {
    success: {
      icon: CheckCircle,
      className: 'bg-green-50 border-green-200 dark:bg-green-900/30 dark:border-green-800',
      iconClass: 'text-green-500 dark:text-green-400',
      textClass: 'text-green-800 dark:text-green-200',
    },
    error: {
      icon: XCircle,
      className: 'bg-red-50 border-red-200 dark:bg-red-900/30 dark:border-red-800',
      iconClass: 'text-red-500 dark:text-red-400',
      textClass: 'text-red-800 dark:text-red-200',
    },
    warning: {
      icon: AlertCircle,
      className: 'bg-amber-50 border-amber-200 dark:bg-amber-900/30 dark:border-amber-800',
      iconClass: 'text-amber-500 dark:text-amber-400',
      textClass: 'text-amber-800 dark:text-amber-200',
    },
    info: {
      icon: Info,
      className: 'bg-blue-50 border-blue-200 dark:bg-blue-900/30 dark:border-blue-800',
      iconClass: 'text-blue-500 dark:text-blue-400',
      textClass: 'text-blue-800 dark:text-blue-200',
    },
  }

  const { icon: Icon, className, iconClass, textClass } = config[type]

  return (
    <div
      className={clsx(
        'flex items-center p-4 rounded-lg border shadow-lg',
        className
      )}
    >
      <Icon className={clsx('w-5 h-5 mr-3 flex-shrink-0', iconClass)} />
      <p className={clsx('text-sm font-medium flex-1', textClass)}>{message}</p>
      <button
        onClick={onClose}
        className={clsx(
          'ml-3 flex-shrink-0 p-1 rounded hover:bg-black/5 dark:hover:bg-white/10',
          textClass
        )}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}

/**
 * ToastContainer - Container for positioning toasts
 */
export const ToastContainer = ({ children }) => {
  return (
    <div className="fixed top-20 right-4 z-50 space-y-2 max-w-sm w-full">
      {children}
    </div>
  )
}

export default Toast
